import React from 'react';
import { DETAILS_CONTENT_KEYS, IPlanContent, KeyDetailsItem } from '../typings/planContent.types';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';
import { OriginGoVariablePromoBox } from './common/originGoVariablePromobox';

import { InternetOfferPerk } from './common/internetOfferPerk';
import { BatteryLitePerk } from './common/BatteryLitePerk';
import { BatteryLiteAboutPlanPerk } from './common/BatteryLiteAboutPlanPerk';
import { BattLiteEligibilityCriteriaModal } from './common/BattLiteEligibilityCriteriaModal';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import { createOnlineCreditsBoxContent } from './common/onlineCredits';

const PLAN_TONE = 'promote';

const PromoBox = <OriginGoVariablePromoBox />;
const defaultKeyDetails: KeyDetailsItem[] = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable + time of use',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable + time of use',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months, No lock ins',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
];

export const originSolarBoostWithBatteryLiteContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Solar Boost with Battery Lite']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period',
      },
    },
    bannerContent: undefined,
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
        dual: [
          {
            contentKey: DETAILS_CONTENT_KEYS.EligibilityCriteiria,
            contentValue: 'Eligibility criteria applies',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EligibilityCriteiria),
            modalContent: BattLiteEligibilityCriteriaModal,
            contentDescription: 'Eligibility criteria applies',
          },
          ...defaultKeyDetails,
        ],
        electricity: [
          {
            contentKey: DETAILS_CONTENT_KEYS.EligibilityCriteiria,
            contentValue: 'Eligibility criteria applies',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EligibilityCriteiria),
            modalContent: BattLiteEligibilityCriteriaModal,
            contentDescription: 'Eligibility criteria applies',
          },
          ...defaultKeyDetails,
        ],
        gas: [
          {
            contentKey: DETAILS_CONTENT_KEYS.EligibilityCriteiria,
            contentValue: 'Eligibility criteria applies',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EligibilityCriteiria),
            modalContent: BattLiteEligibilityCriteriaModal,
            contentDescription: 'Eligibility criteria applies',
          },
          ...defaultKeyDetails,
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        gas: gasKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [BatteryLitePerk, BatteryLiteAboutPlanPerk, InternetOfferPerk],
        gas: [BatteryLitePerk, BatteryLiteAboutPlanPerk, InternetOfferPerk],
        electricity: [BatteryLitePerk, BatteryLiteAboutPlanPerk, InternetOfferPerk],
        defaultFuel: [],
      },
    },
    promoBox: {
      WA: {
        gas: PromoBox,
        defaultFuel: null,
      },
    },
    onlineCredits: createOnlineCreditsBoxContent(
      PLAN_TONE,
      '$100 electricity bill credit',
      'New/moving customers only. Plan must be active on 31 December 24 and you must not have received a credit in the previous 12 months. Not redeemable for cash.'
    ),
    estimatesDialog: defaultEstimatesDialog({
      onlineCreditAmount: 200,
    }),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'purple',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728624900/spot-illustrations/spot_Origin-Solar-Boost.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-solar-boost.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-solar-boost.svg',
          },
          applyPromoBorder: false,
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel:
          'Combine our Solar Boost energy plan with lite VPP orchestration to earn more from your battery.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/terms-and-conditions.html',
      },
    },
  },
};
